import { LooseCargoTypeEnum } from '@zen/types';
import type { Nullable } from '@zen/utils/typescript';

export type Container = {
  description: string;
  hsCodes: string[];
  id: string;
  loose: {
    grossWeight: { metric: string; value: number };
    quantity: number;
    type: Nullable<LooseCargoTypeEnum>;
    volume: number;
  };
  marksAndNumbers: string;
  number: string;
  packagingTypes: string;
  sealNumber: string;
  size: string;
};

export const emptyContainer: Container = {
  id: '',
  description: '',
  hsCodes: [],
  loose: {
    grossWeight: { metric: 'KG', value: 0 },
    quantity: 0,
    type: null,
    volume: 0
  },
  marksAndNumbers: '',
  number: '',
  packagingTypes: '',
  sealNumber: '',
  size: ''
};

export type RawContainer = Omit<Container, 'hsCodes'> & {
  hsCodes: string | string[];
};
